import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NETWORK_STATS, CATEGORIES } from "../lib/network";

const Stat = ({ n, label }) => (
  <div>
    <div className="font-serif text-4xl md:text-6xl text-[#F5F5F0]">{n}</div>
    <div className="font-grotesk text-[10px] uppercase tracking-[0.2em] text-[#8A8A82] mt-2">{label}</div>
  </div>
);

export const NetworkTeaser = () => (
  <section className="bg-[#070707] py-24 md:py-32 border-t border-white/10" data-testid="network-teaser">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-12 items-end">
        <div>
          <span className="overline text-[#B87333]">/ Our Partner Network</span>
          <h2 className="font-serif text-4xl md:text-6xl mt-4 tracking-[-0.02em] leading-[1.05]">
            Trusted by {NETWORK_STATS.total}+ partners<br />across {NETWORK_STATS.states} states &amp; UTs.
          </h2>
          <p className="font-body text-[#8A8A82] mt-6 max-w-xl leading-relaxed">
            A deep, credit-worthy channel of super stockists, wholesalers, dealers, booking agents,
            civil contractors and suppliers — the backbone of Vinci's reliability at scale.
          </p>
          <div className="flex flex-wrap gap-2 mt-8">
            {CATEGORIES.map((c) => (
              <span key={c} className="font-grotesk text-[10px] uppercase tracking-[0.14em] text-[#C9C9C2] border border-white/15 rounded-full px-4 py-2">{c}</span>
            ))}
          </div>
          <Link
            to="/network"
            data-testid="network-teaser-cta"
            className="group inline-flex items-center gap-3 mt-10 rounded-full bg-[#F5F5F0] text-black px-7 py-3.5 font-grotesk text-xs uppercase tracking-[0.2em] hover:bg-[#B87333] transition-colors"
          >
            Explore the network
            <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform" />
          </Link>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 gap-y-12 gap-x-8 lg:pl-10 lg:border-l border-white/10"
        >
          <Stat n={`${NETWORK_STATS.total}+`} label="Affiliated partners" />
          <Stat n={NETWORK_STATS.states} label="States & UTs" />
          <Stat n={NETWORK_STATS.categories} label="Partner categories" />
          <Stat n={NETWORK_STATS.earliest} label="Trusted since" />
        </motion.div>
      </div>
    </div>
  </section>
);
